<div class="cc-single-tab cc-filters" [ngClass]="{'lobby-editor': detailViewId === 2}">
  <ng-container #container></ng-container>
  <!--Filter Panel-->
  <section>
    <form class="filter-options-wrapper" [formGroup]="filtersForm">
      <div class="row align-items-center justify-content-between mb-1">
        <ng-container #container></ng-container>

        <div class="col-md-6 d-flex align-items-center">
          <div class="col-md-4 pl-0">
            <label>{{
              "_Report_Filters_Filter_Templates_Text_" | translate
            }}</label>
            <select
              #editList
              id="editList"
              class="cc-select-dropdown filter-list form-control me-3"
              maxlength="200"
              placeholder="_General_Select_Text_ | translate "
              formControlName="editListDropdown"
              (blur)="templateDropdownOnBlur()"
              (change)="editingTemplateChanged(editList.value)"
            >
              <option
                *ngFor="let value of commonData.templates"
                [ngValue]="value.templateName"
              >
                {{
                  value.templateName == "None"
                    ? ("_Report_Filter_None_Ts_Text_" | translate)
                    : value.templateName
                }}
              </option>
            </select>
          </div>
          <div class="col-md-4 checkbox ps-3">
            <label for="isDefault">
              <input
                class="cc-filter-checkbox"
                kendoCheckBox
                id="isDefault"
                type="checkbox"
                formControlName="isDefault"
                (change)="markAsNotChanged()"
                [disabled]="
                  this.commonData.currentTemplate.templateName == 'None' &&
                  filtersForm.untouched
                "
                [(ngModel)]="this.commonData.currentTemplate.isDefault"
              />
              {{ "_Report_Filters_Default_Template_Text_" | translate }}
            </label>
          </div>
        </div>

        <div class="col-md-6 d-flex justify-content-end">
          <button
            type="button"
            id="filtersDeleteBtn"
            class="btn btn-primary btn-managetemplates me-2"
            (click)="showDelete()"
            *ngIf="hasDeleteTemplatePermission"
            [disabled]="
              this.commonData.currentTemplate.templateName == 'None' ||
              this.commonData.currentTemplate.templateName == 'Custom' ||
              !filtersForm.untouched
            "
          >
            {{ "_General_Button_Delete_Text_" | translate }}
          </button>
          <button
            type="button"
            id="filtersResetBtn"
            class="btn btn-primary btn-managetemplates me-2"
            (click)="showReset()"
            [disabled]="filtersForm.untouched"
          >
            {{ "_General_Button_Reset_Text_" | translate }}
          </button>
          <button
            type="button"
            *ngIf="hasSharedTemplatePermission"
            id="filtersShareBtn"
            class="btn btn-primary btn-managetemplates me-2"
            (click)="showShare()"
            [disabled]="
              !(this.commonData.currentTemplate.templateId >= 1) ||
              !(filtersForm.invalid || filtersForm.untouched)
            "
          >
            {{ "_Report_Filters_Share_Text_" | translate }}
          </button>
          <button
            type="button"
            id="filtersSaveBtn"
            class="btn btn-primary btn-managetemplates me-2"
            (click)="showSave()"
            [disabled]="
              !(this.commonData.currentTemplate.templateId >= 1) ||
              filtersForm.invalid ||
              filtersForm.untouched
            "
          >
            {{ "_General_Button_Save_Text_" | translate }}
          </button>
          <button
            type="button"
            id="filtersSaveAsBtn"
            class="btn btn-primary btn-managetemplates"
            (click)="showSaveAs()"
            [disabled]="
              (this.commonData.currentTemplate.templateName == 'None' &&
                filtersForm.untouched) ||
              (this.commonData.currentTemplate.templateId >= 1 &&
                filtersForm.untouched) ||
              filtersForm.invalid
            "
          >
            {{ "_General_Save_As_Text_" | translate }}
          </button>
        </div>
      </div>
      <!-- *ngIf="this.commonData.currentTemplate.templateName != 'Unfiltered' && this.commonData.currentTemplate.templateName != 'Unsaved' "> -->

      <div class="filter-list-wrapper mt-4 mb-2">
        <div class="row mt-2">
          <!-- Where and When -->
          <div class="col-md-6">
            <div class="mimic-field-set wr-location">
              <h1>
                <span class="field-set-title">{{
                  "_Report_Filters_WhereWhen_Text_" | translate
                }}</span>
              </h1>
              <div class="mb-2">
                <label>{{ "_General_Locations_Text_" | translate }}</label>
                <ng-multiselect-dropdown
                  #locationDropdownRef
                  formControlName="locationDropdown"
                  [placeholder]="
                    commonData.options.locations.length == 0
                      ? ('_General_No_Branches_Text_' | translate)
                      : ('_General_Select_Text_' | translate)
                  "
                  [attr.title]="
                    commonData.options.locations.length == 0
                      ? null
                      : ('_General_Select_Text_' | translate)
                  "
                  [ngClass]="{
                    'dropdown-disabled': commonData.options.locations.length == 0
                  }"
                  [settings]="locationDropdownSettings"
                  [data]="commonData.options.locations"
                  [(ngModel)]="commonData.options.selectedLocations"
                  (onSelect)="onLocationSelect()"
                  (onSelectAll)="onSelectAllLocations($event)"
                  (onDeSelect)="onLocationDeSelect()"
                  (onDeSelectAll)="onDeSelectAllLocations($event)"
                  (onFilterChange)="onLocationFilterChange()"
                  (onDropDownClose)="onLocationsDropdownClose()"
                  [disabled]="commonData.options.locations.length == 0"
                  class="search-icon-enabled"
                ></ng-multiselect-dropdown>
              </div>
              <div *ngIf="commonData.useTimePeriod" class="mb-2">
                <label>{{
                  "_Report_Filters_TimePeriod_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  formControlName="timePeriodDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="timePeriodDropdownSettings"
                  [data]="commonData.options.timePeriods"
                  [(ngModel)]="commonData.options.selectedTimePeriod"
                  (onSelect)="onTimePeriodSelect()"
                  (onDeSelect)="onTimePeriodDeSelect()"
                ></ng-multiselect-dropdown>
              </div>
              <div>
                <label>{{
                  "_Report_Filters_Day_of_Week_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  formControlName="dayOfWeekDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="dayOfWeekDropdownSettings"
                  [data]="commonData.options.daysOfWeek"
                  [(ngModel)]="commonData.options.selectedDaysOfWeek"
                  (onSelect)="onDayOfWeekSelect()"
                  (onSelectAll)="onSelectAllDaysOfWeek($event)"
                  (onDeSelect)="onDayOfWeekDeSelect()"
                  (onDeSelectAll)="onDeSelectAllDaysOfWeek($event)"
                ></ng-multiselect-dropdown>
              </div>
            </div>
          </div>
          <!-- Staff -->
          <div class="col-md-6">
            <div class="mimic-field-set wr-staff ms-1">
              <h1>
                <span class="field-set-title">{{
                  "_General_Staff_Text_" | translate
                }}</span>
              </h1>
              <div class="mb-2">
                <label>{{
                  "_General_Report_Requested_Staff_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  #requestedStaffDropdownRef
                  formControlName="userRequestedDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="userRequestedDropdownSettings"
                  [data]="commonData.options.requestedStaff"
                  [(ngModel)]="commonData.options.selectedRequestedStaff"
                  (onSelect)="onRequestedUserSelect()"
                  (onSelectAll)="onSelectAllRequestedUsers($event)"
                  (onDeSelect)="onRequestedUserDeSelect()"
                  class="search-icon-enabled"
                  (onFilterChange)="onRequestedStaffFilterChange()"
                  (onDeSelectAll)="onDeSelectAllRequestedUsers($event)"
                  (onDropDownClose)="onRequestedStaffDropdownClose()"
                ></ng-multiselect-dropdown>
              </div>
              <div class="mb-2">
                <label>{{
                  "_Report_Filters_Supervisor_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  #supervisorDropdownRef
                  formControlName="supervisorDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="supervisorDropdownSettings"
                  [data]="commonData.options.supervisors"
                  [(ngModel)]="commonData.options.selectedSupervisors"
                  (onSelect)="onSupervisorSelect($event)"
                  (onSelectAll)="onSelectAllSupervisors($event)"
                  (onDeSelect)="onSupervisorDeSelect()"
                  (onDeSelectAll)="onDeSelectAllSupervisors($event)"
                  class="search-icon-enabled"
                  (onFilterChange)="onSupervisorFilterChange()"
                  (onDropDownClose)="onSupervisorDropdownClose()"
                ></ng-multiselect-dropdown>
              </div>
              <div>
                <label>{{
                  "_General_Report_AssistedBy_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  #assistedByDropdownRef
                  formControlName="assistedByDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="assistedByDropdownSettings"
                  [data]="commonData.options.filteredAssistedBys"
                  [(ngModel)]="commonData.options.selectedAssistedBys"
                  (onSelect)="onAssistedBySelect()"
                  (onSelectAll)="onSelectAllAssistedBys($event)"
                  (onDeSelect)="onAssistedByDeSelect()"
                  class="search-icon-enabled"
                  (onFilterChange)="onAssistedByFilterChange()"
                  (onDeSelectAll)="onDeSelectAllAssistedBys($event)"
                  (onDropDownClose)="onAssistedByDropdownClose()"
                ></ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <!-- Product/Services & Sign In/Out -->
          <div class="col-md-6">
            <div>
              <div class="mimic-field-set wr-staff">
                <h1>
                  <span class="field-set-title">{{
                    "_General_Products_Services_Text_" | translate
                  }}</span>
                </h1>
                <div class="mb-2">
                  <label>{{ "_General_Category_Text_" | translate }}</label>
                  <ng-multiselect-dropdown
                    #categoryDropdownRef
                    formControlName="categoryDropdown"
                    [placeholder]="'_General_Select_Text_' | translate"
                    [settings]="categoryDropdownSettings"
                    [data]="commonData.options.categories"
                    [(ngModel)]="commonData.options.selectedCategories"
                    (onSelect)="onCategorySelect()"
                    (onSelectAll)="onSelectAllCategories($event)"
                    (onDeSelect)="onCategoryDeSelect()"
                    (onDeSelectAll)="onDeSelectAllCategories($event)"
                    class="search-icon-enabled"
                    (onFilterChange)="onCategoryFilterChange()"
                    (onDropDownClose)="onCategoryDropdownClose()"
                  ></ng-multiselect-dropdown>
                </div>
                <div>
                  <label>{{
                    "_General_Products_Services_Text_" | translate
                  }}</label>
                  <ng-multiselect-dropdown
                    #serviceDropdownRef
                    formControlName="serviceDropdown"
                    [placeholder]="'_General_Select_Text_' | translate"
                    [settings]="serviceDropdownSettings"
                    [data]="commonData.options.filteredServices"
                    [(ngModel)]="commonData.options.selectedServices"
                    (onSelect)="onServiceSelect($event)"
                    (onSelectAll)="onSelectAllServices($event)"
                    (onDeSelect)="onServiceDeSelect()"
                    class="search-icon-enabled"
                    (onFilterChange)="onServiceFilterChange()"
                  (onDeSelectAll)="onDeSelectAllServices($event)"
                  (onDropDownClose)="onServiceDropdownClose()"
                  ></ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <div
              class="mt-4 sign-in-out-users-section"
              [hidden]="!showViewFilters || !hasViewSignInOutReportPermission"
            >
              <div class="mimic-field-set wr-staff">
                <h1>
                  <span class="field-set-title">{{
                    "_Report_Filters_SignInOut_Text_" | translate
                  }}</span>
                </h1>
                <div>
                  <label>{{ "_General_Report_Users_Text_" | translate }}</label>
                  <ng-multiselect-dropdown
                    #usersDropdownRef
                    formControlName="signedInUsersDropdown"
                    [placeholder]="'_General_Select_Text_' | translate"
                    [settings]="usersDropdownSettings"
                    [data]="commonData.options.users"
                    [(ngModel)]="commonData.options.selectedUsers"
                    (onSelect)="onUsersSelect()"
                    (onSelectAll)="onSelectAllUsers($event)"
                    (onDeSelect)="onUsersDeSelect()"
                    class="search-icon-enabled"
                    (onFilterChange)="onUsersFilterChange()"
                  (onDeSelectAll)="onDeSelectAllUsers($event)"
                  (onDropDownClose)="onUsersDropdownClose()"
                  ></ng-multiselect-dropdown>
                </div>
              </div>
            </div>
          </div>
          <!-- Other -->
          <div class="col-md-6">
            <div class="mimic-field-set wr-staff ms-1">
              <h1>
                <span class="field-set-title">{{
                  "_Report_Filters_Other_Text_" | translate
                }}</span>
              </h1>
              <div class="mb-2">
                <label>{{ "_Report_Status_Ts_Text_" | translate }}</label>
                <ng-multiselect-dropdown
                  formControlName="statusDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="statusDropdownSettings"
                  [data]="commonData.options.statuses"
                  [(ngModel)]="commonData.options.selectedStatuses"
                  (onSelect)="onStatusSelect()"
                  (onSelectAll)="onSelectAllStatuses($event)"
                  (onDeSelect)="onStatusDeSelect()"
                  (onDeSelectAll)="onDeSelectAllStatuses($event)"
                ></ng-multiselect-dropdown>
              </div>
              <div class="mb-2">
                <label>{{
                  "_Report_Filters_Auto_Wrap_Up_Records_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  formControlName="autoWrapUpStatusDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="autoWrapUpStatusDropdownSettings"
                  [data]="commonData.options.autoWrapUpStatus"
                  [(ngModel)]="commonData.options.selectedAutoWrapUpStatus"
                  (onSelect)="onAutoWrapUpStatusSelect($event)"
                  (onDeSelect)="onAutoWrapUpStatusDeSelect($event)"
                ></ng-multiselect-dropdown>
              </div>
              <div class="mb-2">
                <label>{{ "_General_Assist_Type_Text_" | translate }}</label>
                <ng-multiselect-dropdown
                  formControlName="assistTypeDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="assistTypeDropdownSettings"
                  [data]="commonData.options.assistTypes"
                  [(ngModel)]="commonData.options.selectedAssistTypes"
                  (onSelect)="onAssistTypeSelect()"
                  (onSelectAll)="onSelectAllAssistTypes($event)"
                  (onDeSelect)="onAssistTypeDeSelect()"
                  (onDeSelectAll)="onDeSelectAllAssistTypes($event)"
                ></ng-multiselect-dropdown>
              </div>
              <div class="default-view-section" *ngIf="showViewFilters">
                <label>{{
                  "_Report_Filters_DefaultView_Text_" | translate
                }}</label>
                <ng-multiselect-dropdown
                  formControlName="viewDropdown"
                  [placeholder]="'_General_Select_Text_' | translate"
                  [settings]="viewDropdownSettings"
                  [data]="filteredDefaultViews"
                  [(ngModel)]="commonData.options.selectedViews"
                  (onSelect)="onViewSelect()"
                  (onDeSelect)="onViewDeSelect()"
                ></ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex mt-3 align-items-end justify-content-end">
        <!-- <div class="text-search-wrapper me-2">
          <input class="form-control txt-search" maxlength="200" formControlName="search" type="text" name="search"
            placeholder="{{'_General_Search_Text_' | translate }}" id="search" (change)="searchChanged($event)"
            [(ngModel)]="commonData.options.searchTerms[0].searchTerm" app-no-lead-ws app-filter
            pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$">
        </div> -->
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-cancel me-2"
            (click)="cancel()"
          >
            {{ "_General_Button_Close_Text_" | translate }}
          </button>
          <button
            type="button"
            id="filtersApplyBtn"
            class="btn btn-primary btn-apply"
            (click)="apply(filtersForm.value)"
            [disabled]="filtersForm.invalid"
            title="{{ applyTooltipText }}"
          >
            {{ "_General_Button_Apply_Text_" | translate }}
          </button>
        </div>
      </div>
    </form>
  </section>
</div>

<kendo-dialog
  title="{{ '_General_Message_Reset_Default_Text_' | translate }}"
  *ngIf="showResetDialog"
  [minWidth]="300"
  [width]="500"
  (close)="closeResetDialog()"
>
  <kendo-dialog-messages
    closeTitle="{{ '_General_Button_Close_Text_' | translate }}"
  ></kendo-dialog-messages>

  <div>
    {{ "_Report_Filters_Reset_To_Default_Description_Text_" | translate }}
  </div>

  <kendo-dialog-actions class="cc-btn-panel">
    <button class="btn btn-secondary" (click)="closeResetDialog()">
      {{ "_General_Action_Label_No_Text_" | translate }}
    </button>
    <button class="btn btn-primary" (click)="reset()">
      {{ "_General_Action_Label_Yes_Text_" | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<delete-filter-template
  [(dialogOpened)]="showDeleteDialog"
  [(templateName)]="commonData.currentTemplate.templateName"
  (deleted)="DeleteTemplateYesClicked()"
  (canceled)="DeleteTemplateCancelClicked()"
></delete-filter-template>

<save-filter-template
  [(saveDialogOpened)]="showSaveDialog"
  [(templateName)]="commonData.currentTemplate.templateName"
  [(templateId)]="commonData.currentTemplate.templateId"
  (submitted)="SaveTemplateClicked($event)"
  (canceled)="SaveTemplateCancelClicked()"
></save-filter-template>

<save-as-filter-template
  [(saveAsDialogOpened)]="showSaveAsDialog"
  (submitted)="SaveAsTemplateClicked($event)"
  (canceled)="SaveAsTemplateCancelClicked()"
></save-as-filter-template>

<share-filter-template
  [(shareDialogOpened)]="showShareDialog"
  [shareableUsersList]="commonData.options.shareableUsers"
  [shareablePermissionGroupsList]="commonData.options.shareablePermissionGroups"
  [(sharedUsers)]="sharedUsers"
  [(sharedPermissionGroups)]="sharedPermissionGroups"
  (submitted)="ShareTemplateClicked($event)"
  (canceled)="ShareTemplateCancelClicked()"
></share-filter-template>
